/* global setInterval, clearInterval */

import React from 'react'
import PropTypes from 'prop-types'

import { hashHistory } from 'react-router'
import { connect } from 'react-redux'
import * as firebase from 'firebase'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import CircularProgress from 'material-ui/CircularProgress'
import injectTapEventPlugin from 'react-tap-event-plugin'

import FirebaseManager from './infra/components/FirebaseManager'
import AnalyticsManager from './infra/analytics/AnalyticsManager'
import LocationManager from './infra/components/LocationManager'
import Analytics from './infra/analytics/Analytics'

injectTapEventPlugin()
const SESSION_INTERVAL = 1000 * 60 * 30 //30 mins
const updateTrackerSession = () => {
  Analytics.track(Analytics.DASHBOARD_RESUMED)
}

class Main extends React.Component {

  static propTypes = {
    userAuth: PropTypes.object,
    location: PropTypes.object.isRequired,
    children: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  }

  componentWillMount() {
    this.onAuthListener = firebase.auth().onAuthStateChanged(this.onAuthStateChanged.bind(this))
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'ANALYTICS_UPDATE_INFO'
    })
    this.intervalId = setInterval(updateTrackerSession, SESSION_INTERVAL)
  }

  onAuthStateChanged(user) {
    const path = this.props.location.pathname
    if (!user && path.indexOf('login') === -1) {
      // Not logged in or user logout
      hashHistory.push('login')
    }
    else
    if (user && path.indexOf('login') === -1) {
      hashHistory.push('app/schedule')
    }
  }

  componentWillUnmount() {
    this.onAuthListener()
    clearInterval(this.intervalId)
    Analytics.track(Analytics.DASHBOARD_CLOSED)
  }

  render() {
    return (
      <MuiThemeProvider
        muiTheme={muiTheme}>
        <div id="root-wrapper"
          style={{ height: '100%', textAlign: 'center', backgroundColor: '#f1f1f1' }}>
          {
            this.props.userAuth.loading
              ? <CircularProgress size={60} thickness={2} style={{ marginTop: 100 }} />
              : this.props.children
          }
          <FirebaseManager />
          <AnalyticsManager />
          <LocationManager />
        </div>
      </MuiThemeProvider>
    )
  }
}

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#527da3'
  },
  // Override text transformation property as
  // default capitalizes raised buttons text.
  raisedButton: {
    textTransform: 'none'
  },
  flatButton: {
    textTransform: 'none'
  }
})

export default connect(state => ({ userAuth: state.firebase.userAuth }))(Main)



// WEBPACK FOOTER //
// ./src/Main.js